<h1 translate
    matDialogTitle>
    {{ type + '_upload_package_modal_title' }}
</h1>

<mat-dialog-content uiDragAndDropFile
                    [fileBrowseRef]="browseTrigger"
                    [fileClearRef]="clearTrigger"
                    [multiple]="true"
                    (fileChange)="onFileChange($event)"
                    (fileClear)="onClear()"
                    fileType=".nupkg"
                    data-cy="nuget-upload-container">
    <div class="layout-row">
        <mat-form-field class="flex">
            <input [value]="fileNames"
                   [placeholder]="type + '_upload_package_modal_file_input_placeholder' | translate"
                   matInput
                   readonly
                   data-cy="nuget-file-name-input" />
        </mat-form-field>

        <div #clearTrigger>
            <button *ngIf="files.length"
                    mat-icon-button
                    type="button">
                <mat-icon>cancel</mat-icon>
            </button>
        </div>

        <label #browseTrigger>
            <button mat-button
                    color="primary"
                    class="ui-upload-button"
                    type="button">
                <mat-icon>folder</mat-icon>
                <span translate
                      class="text-upper">
                    modal_action_browse
                </span>
            </button>
        </label>
    </div>
    <em translate>
        {{ type + '_upload_package_modal_upload_progress_info' }}
    </em>
    <div class="upgrade-checkbox">
        <mat-checkbox *ngIf="type === 'packages'"
                      [disabled]="!files.length"
                      (change)="checkUpgradeValue($event)"
                      data-cy="nuget-upgrade-checkbox">
            {{ 'package_upload_package_modal_upgrade_action' | translate }}
        </mat-checkbox>
    </div>
</mat-dialog-content>

<mat-dialog-actions *ngLet="{
                        loading: loading$ | async,
                        showProgressBar: showProgressBar$ | async,
                        progress: progress$ | async
                    } as state"
                    align="end">
    <button mat-dialog-close
            mat-button
            type="button"
            data-cy="nuget-file-close">
        {{ 'modal_action_cancel' | translate }}
    </button>
    <button [progressButtonLoading]="state.showProgressBar"
            [progressButtonValue]="state.progress"
            [disabled]="state.loading ||
                        !files.length"
            (click)="onSubmit()"
            progressButtonMode="determinate"
            ui-progress-button
            mat-flat-button
            color="primary"
            type="button"
            data-cy="nuget-file-upload">
        {{ 'modal_action_upload' | translate }}
    </button>
</mat-dialog-actions>
